import { useState, useRef } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import FormatDecimal from "../../helpers/FormatDecimal";


import edit from "../../edit.png";
import trash from "../../trash.png";
import InputCombo from "../../helpers/InputCombo";
import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import NoticeOnlineEdit from "./NoticeOnlineEdit";
import MenuTable from "../../helpers/MenuTable";
import AppContext from "../../AppContext";
import NoticeCreate from "./NoticeCreate";
import Csv from "../../exporter/Csv";
import Xlsx from "../../exporter/Xlsx";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";


function NoticeOnline(props)
{


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

 

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({  
        dz_imie_nazwisko: '', 
        status: '_x_',
        created_at_from: '',
        created_at_to: '',
        numer_zgloszenia: '',

   

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });

    const [tab, setTab] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);

    const [reqLink, setReqLink] = useState("");
 

    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0); //do druku


    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );

    const [legend, setLegend] = useState([
        {
            cls:'color_show1',
            title: 'Nowe zgłoszenie'
        },
    ]);





    //-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = 0;

    if(e.target.checked) selected = 1;

    for(var k=0; k<selectedRow.length; k++)
    {
        if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
    }

    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
}

const changeSelectedAll = (e) => {

    var s = selectedRow[0].selected;
    if(s == 1) {  s = 0; } else s = 1;

    for(var k=0; k<selectedRow.length; k++)
        {
          selectedRow[k].selected = s;
        }
    
        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

}


//-------------------------------------------------------
//-------------------------------------------------------


const goDeleteMass = () => {



    var ids = new Array();
    
        for(var k=0; k<selectedRow.length; k++)
            {
               if( selectedRow[k].selected == 1)
               {
                    ids.push({
                        id: selectedRow[k].id,
                        title: selectedRow[k].title
                    });
               }
            }
        
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego zgłoszenia' ,  "ok"  ,null); 
            return;              
         }
    


         props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć wybrane zgłoszenia?", "yesno", (option)=>{
        
            ///--------
            if(option == "yes") 
            {

                            props.mainView.setProgress(-2);

                            var req = {
                                ids: ids
                            }
                    
                            fetch( Config.url + '/rest_v1_kids,notice_online_del', {
                                method: 'POST', 
                                body: JSON.stringify(req), 
                                headers: {
                                    'Content-Type': 'application/json',                    
                                    'X-Api-Key': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => {             
                                        
                                        props.mainView.setProgress(-1);
                    
                                        if(res._sys_ == undefined)
                                        {
                                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                        }else
                                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                        {
                                            props.mainView.showDialog( "Error", "Something is wrong: ext:" + JSON.stringify(res) , "ok" , null);  
                                        }else
                                        if(res.status != undefined && res.status == "OK")
                                        {
                                            props.mainView.showDialog( "Sukces",  "Zgłoszenia zostały usunięte", "ok" , null);                        
                                            setTab(null);
                                        }else
                                        {
                                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                                        }
                                    
                            } )
                            .catch(err => {   
                                        props.mainView.setProgress(-1);       
                                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                            });
                       
            }
            //--------
} );


 

}


const goDelete = (e) => {

    
        var id = e.target.getAttribute("id");

        var ids = new Array();


        ids.push({
            id: id,
            title: "",
        });

     
        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć wybrane zgłoszenie?", "yesno", (option)=>{
        
                        ///--------
                        if(option == "yes") 
                        {

                                        props.mainView.setProgress(-2);

                                        var req = {
                                            ids: ids
                                        }
                                
                                        fetch( Config.url + '/rest_v1_kids,notice_online_del', {
                                            method: 'POST', 
                                            body: JSON.stringify(req), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                                '_p_dziecko_id_': props.userData.p_dziecko_id,
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => {             
                                                    
                                                    props.mainView.setProgress(-1);
                                
                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Error", "Something is wrong: ext:" + JSON.stringify(res) , "ok" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == "OK")
                                                    {
                                                        props.mainView.showDialog( "Sukces",  "Zgłoszenie zostało usunięte", "ok" , null);                        
                                                        setTab(null);
                                                    }else
                                                    {
                                                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                                                    }
                                                
                                        } )
                                        .catch(err => {   
                                                    props.mainView.setProgress(-1);       
                                                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                        });
                                   
                        }
                        //--------
        } );
}






const changeView = (e ) => {
    var v = e.target.getAttribute('v');
    var id = e.target.getAttribute('id');

    setView({...view, ["v"]:v, ["id"]:id });
}


 




const getTab = () => {
       
 
    props.mainView.setProgress(-2);

   

    fetch( Config.url + '/rest_v1_kids,notice_online', {
        method: 'POST', 
        body: JSON.stringify(filterParam), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setTab(res.result);            


                    var newSelector = [];

                    res.result.forEach( (item) => {
                        newSelector.push({
                            id: item.id,
                            title: item.imie  + "  " + item.nazwisko,
                            selected: 0,
                        });
                    } )

                    setSelectedRow(newSelector);


                    if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}



const getLink = () => {
       
 
    props.mainView.setProgress(-2);

   

    fetch( Config.url + '/rest_v1_kids,notice_online_link', {
        method: 'POST', 
        body: JSON.stringify({}), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setReqLink(res.result.link);                        
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}





const valChangeListener = (filedName, val, correct, msg) => {

    // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

     setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
     
     if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
        {
                var defTimeOut = 1000;
                if(msg == 'combo') defTimeOut = 10;
                clearTimeout(AppContext.timeoutId);
                AppContext.timeoutId = setTimeout( () => {
                    setTab(null); 
                } , defTimeOut );
        }

     props.mainView.writeFilter(filedName, val);
 }


 const goNextNew = () => {
     console.log("goNext");    
     setTab(null);    
 }


 const filterView = () => {
    setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
}



 const filterClear = () => {
 
   

     setFilterParam({
       
       
        dz_imie_nazwisko: '',    
        status: '_x_',
        created_at_from: '',
        created_at_to: '',
        numer_zgloszenia: '',
        

         sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

         limit: 50,
         page: 1,
         show: true
     });
     setTab(null);
 }

 const filterApprove = () => {   
     setTab(null)     
 }

 const onChangePagger = (x_limit, x_page) => {

     setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
     setTab(null);
 }


 const onChangeSortBy = (sortBy) => {

    setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
    setTab(null);
}



const onBack = () => {
  

    setView( {
        v:'list',
        id: -1
    } );
}


const onSuccess = () => {
    setTab(null);

    setView( {
        v:'list',
        id: -1
    } );
}


if(reqLink.length < 3)
{
    setReqLink("......");
    getLink();
}

if(tab == null)
    {
        setTab([]);
        getTab();
     

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
        setView( {
            v:'list',
            id: -1
        });
    }






    if(view.v == 'edit')
        {          

            var idx = -1;

            for(var k=0; k<tab.length; k++)
            {
                if(tab[k].id == view.id)  {
                    idx = k; break;
                }
            }

            return <NoticeOnlineEdit    userData={props.userData}  mainView={props.mainView}    row={tab[idx]} onBack={onBack} onSuccess={onSuccess}  />
        }


        if(view.v == 'create')
            {          
    
                var idx = -1;
    
                for(var k=0; k<tab.length; k++)
                {
                    if(tab[k].id == view.id)  {
                        idx = k; break;
                    }
                }
    
                return <NoticeCreate    userData={props.userData}  mainView={props.mainView}    row={tab[idx]} onBack={onBack} onSuccess={onSuccess}  />
            }

 
    var zaznaczonych = 0;
    for(var s=0; s<selectedRow.length; s++)
    {
        if(selectedRow[s].selected == 1) zaznaczonych ++;
    }



    var sortList = [ 
        {column: "dziecko", name: "Dziecko"  }, 
        {column: "created_at", name: "Data utworzenia"  }, 
    ]



    var itemsStatus = [
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: 'NOWE',
            title: 'Nowe'
        }, 
        {
            v: 'W TRAKCIE WERYFIKACJI',
            title: 'W trakcie weryfikacji'
        },       
        {
            v: 'ODRZUCONE',
            title: 'Odrzucone'
        },    
        {
            v: 'WYMAGANE WPISOWE + WYŚWIETL FORMULARZ PŁATNOŚCI BlueMedia',
            title: 'Wymagana opł. rekrutacyjna + wyświetl formularz płatności'
        }, 
        {
            v: 'PRZYJĘTE - OPŁACONE PRZEZ RODZICA - Blue Media',
            title: 'Opłacone przez rodzica (OnLine)'
        },  
        {
            v: 'PRZYJĘTE - OPŁACONE PRZEZ RODZICA - Inny sposób',
            title: 'Opłacone przez rodzica (Inny sposób)'
        },  
        {
            v: 'PRZYJĘTE - OPŁACONE - UTWORZONE W SYSTEMIE',
            title: 'Dziecko przyjęte i utworzone w systemie'
        },          

    ];




    return   <div className="view_content">
             

                 <div className="bg_center">
                    <br/>
                     Link do umieszczenia na stronie i w mediach społecznościowych: 
                     <br/>
                     <a href={reqLink} className="link_color" target="_blank">
                            {reqLink}
                     </a>                     
                     <br/>&nbsp;
                </div>


                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                {
                    filterParam.show == true  &&
                  <div className="table_filter">


                    <div className="filter_controll filter_merge">   
                            <label>Data utworzenia (od dnia / do dnia): </label>      <br/>                       
                            <InputDate   userData={props.userData} value={filterParam.created_at_from}   valChange={valChangeListener} goNext={goNextNew} name="created_at_from" placeholder={"Od dnia: "}   />                                                                  
                            <InputDate   userData={props.userData} value={filterParam.created_at_to}   valChange={valChangeListener} goNext={goNextNew} name="created_at_to" placeholder={"Do dnia: "}   />
                    </div> 


                    <div className="filter_controll">   
                            <label>Numer zgłoszenia: </label>                             
                            <InputText   userData={props.userData} value={filterParam.numer_zgloszenia}   valChange={valChangeListener} goNext={goNextNew} name="numer_zgloszenia" placeholder={"Numer zgłoszenia: "}   />
                        </div>  


                        <div className="filter_controll">   
                            <label>Dziecko: </label>                             
                            <InputTextAlpha   userData={props.userData} value={filterParam.dz_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="dz_imie_nazwisko" placeholder={"Dziecko: "}   />
                        </div>  


                        <div className="filter_controll">   
                            <label>Status zgłoszenia: </label>                             
                            <InputCombo  items={itemsStatus}  userData={props.userData}  mainView={props.mainView}  value={filterParam.status}   valChange={valChangeListener} goNext={goNextNew} name="status"    />
                        </div> 



                     



                        <div className="filter_btn">
                                <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                        </div>
                    </div>
                } 

               


 

                <div className="bg_center">
 

                           <div className="table_mass">  
                                        <div className="title_mass">Operacje masowe (zaznaczono: {zaznaczonych}) </div>
   

                                        &nbsp;
                                        <span className="btn" onClick={goDeleteMass} > usuń zaznaczone</span>    
                                                                                          
                        </div>


                                
                      <div className="table_widget">                                    

                            <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                
                            <InputLegend items={legend}/>

                            <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  

                                &nbsp; &nbsp;
                            <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title="Zgłoszenia" />   
                            <Csv tabRef={tab2Ref} title="Zgłoszenia.csv"/>                  
                            <Xlsx tabRef={tab2Ref} title="Zgłoszenia.xlsx" />                  
                            <Print tabRef={tab2Ref} />
                        </div>



              <div className="gohide" ref={tabRef}>
                                                <h3>Zgłoszenia </h3>  

                                         <table className="table" ref={tab2Ref} >

                            <thead>
                                    <tr className="header">
                                                    <td className="link_normal td_left" onClick={changeSelectedAll}>Z</td>   
                                                    <td>LP</td>                                                                                       
                                                    <td>Numer zgłoszenia</td>                                                         
                                                    <td >Data utworzenia</td>                                
                                                    <td>Status</td>                                                                                       
                                                    <td>Dziecko</td>
                                                    <td>Telefon</td>
                                                    <td>E-mail</td>
                                                    <td>Data urodzennia</td>
                                                    <td>Miasto</td>                                                  
                                                    <td>Prop. data przyjęcia</td>                                                  
                                                    <td>Wysokość opł. rek.</td>                                                  
                                                    <td className="td_right">Wysokość kwota wpłacona</td>                                                                                                                                                      
                                                                                    
                                                                                   
                                    </tr>
                            </thead>
                            <tbody>
                                {
                                    tab.map(  (item,ix) => {

                                        var isChecked = "";

                                        for(var s=0; s<selectedRow.length; s++)
                                            {
                                                if( selectedRow[s].id == item.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                            }


                                        var css =  "";
                                        if(item.status == "NOWE") css = " color_show1 ";


                                        var status = item.status;

                                        if(item.status == 'NOWE') {  status = "Nowe"; }
                                        if(item.status == 'W TRAKCIE WERYFIKACJI') {  status = "W trakcie weryfikacji"; }
                                        if(item.status == 'ODRZUCONE') {  status = "Odrzucone"; }
                                        if(item.status == 'WYMAGANE WPISOWE + WYŚWIETL FORMULARZ PŁATNOŚCI BlueMedia') {  status = "Wymagana opł rekrutacyjna + wyświetl formularz płatności"; }
                                        if(item.status == 'PRZYJĘTE - OPŁACONE PRZEZ RODZICA - Blue Media') {  status = "Opłacone przez rodzica (OnLine)"; }
                                        if(item.status == 'PRZYJĘTE - OPŁACONE PRZEZ RODZICA - Inny sposób') {  status = "Opłacone przez rodzica (Inny sposób)"; }
                                        if(item.status == 'PRZYJĘTE - OPŁACONE - UTWORZONE W SYSTEMIE') {  status = "Dziecko przyjęte i utworzone w systemie"; }
                                   

                                        var rowStyle = " row ";
                                        if(ix % 2 == 0 )rowStyle = " row2 ";


                                        return <tr className={ rowStyle + css } key={ix}>
                                                    <td className="gocenter">
                                                        <input type="checkbox" atr-id={item.id} onChange={changeSelected} checked={isChecked} />
                                                    </td>  
                                                    <td className="gocenter">{ix+1}</td>                                                                                       
                                                    <td className="gocenter">{item.numer_zgloszenia}</td>                                                                        
                                                    <td className="td_right" >{item.created_at}</td>                  
                                                    <td className="gocenter">{status}</td>                                                                                       
                                                    <td className="">{item.nazwisko + " " + item.imie}</td>
                                                    <td className="">{item.telefon_kontaktowy} &nbsp; {item.r1_telefon}  &nbsp;{item.r2_telefon}</td>
                                                    <td className="">{item.e_mail} &nbsp; {item.r1_email} &nbsp; {item.r2_email}</td>
                                                    <td className="gocenter">{item.data_urodzenia}</td>
                                                    <td className="gocenter">{item.miasto}</td>                                                  
                                                    <td className="gocenter">{item.proponowana_data_przyjecia}</td>                                                  
                                                    <td className="goright"><FormatDecimal value={item.kwota_wpisowa} /></td>                                                  
                                                    <td className="goright"><FormatDecimal value={item.kwota_zaplacona} /></td>    

                                         

                                        </tr>
                                    } )
                                }
                            </tbody>

                </table>

             </div>



            <div className="scorll_x">
                <table className="table" ref={tabRef}>

                            <thead>
                                    <tr className="header">
                                                    <td className="link_normal td_left" onClick={changeSelectedAll}>Z</td>   
                                                    <td>LP</td>                                                                                       
                                                    <td>Numer zgłoszenia</td>                                                         
                                                    <td >Data utworzenia</td>                                
                                                    <td>Status</td>                                                                                       
                                                    <td>Dziecko</td>
                                                    <td>Telefon</td>
                                                    <td>E-mail</td>
                                                    <td>Data urodzennia</td>
                                                    <td>Miasto</td>                                                  
                                                    <td>Prop. data przyjęcia</td>                                                  
                                                    <td>Wysokość opł. rek.</td>                                                  
                                                    <td className="td_right">Wysokość kwota wpłacona</td>                                                                                                                                                      
                                                    <td className="td_option"> </td>                                      
                                                                                   
                                    </tr>
                            </thead>
                            <tbody>
                                {
                                    tab.map(  (item,ix) => {

                                        var isChecked = "";

                                        for(var s=0; s<selectedRow.length; s++)
                                            {
                                                if( selectedRow[s].id == item.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                            }


                                        var css =  "";
                                        if(item.status == "NOWE") css = " color_show1 ";


                                        var status = item.status;

                                        if(item.status == 'NOWE') {  status = "Nowe"; }
                                        if(item.status == 'W TRAKCIE WERYFIKACJI') {  status = "W trakcie weryfikacji"; }
                                        if(item.status == 'ODRZUCONE') {  status = "Odrzucone"; }
                                        if(item.status == 'WYMAGANE WPISOWE + WYŚWIETL FORMULARZ PŁATNOŚCI BlueMedia') {  status = "Wymagana opł rekrutacyjna + wyświetl formularz płatności"; }
                                        if(item.status == 'PRZYJĘTE - OPŁACONE PRZEZ RODZICA - Blue Media') {  status = "Opłacone przez rodzica (OnLine)"; }
                                        if(item.status == 'PRZYJĘTE - OPŁACONE PRZEZ RODZICA - Inny sposób') {  status = "Opłacone przez rodzica (Inny sposób)"; }
                                        if(item.status == 'PRZYJĘTE - OPŁACONE - UTWORZONE W SYSTEMIE') {  status = "Dziecko przyjęte i utworzone w systemie"; }
                                   

                                        var rowStyle = " row ";
                                        if(ix % 2 == 0 )rowStyle = " row2 ";


                                        return <tr className={ rowStyle + css } key={ix}>
                                                    <td className="gocenter">
                                                        <input type="checkbox" atr-id={item.id} onChange={changeSelected} checked={isChecked} />
                                                    </td>  
                                                    <td className="gocenter">{ix+1}</td>                                                                                       
                                                    <td className="gocenter">{item.numer_zgloszenia}</td>                                                                        
                                                    <td className="td_right" >{item.created_at}</td>                  
                                                    <td className="gocenter">{status}</td>                                                                                       
                                                    <td className="">{item.nazwisko + " " + item.imie}</td>
                                                    <td className="">{item.telefon_kontaktowy} &nbsp; {item.r1_telefon}  &nbsp;{item.r2_telefon}</td>
                                                    <td className="">{item.e_mail} &nbsp; {item.r1_email} &nbsp; {item.r2_email}</td>
                                                    <td className="gocenter">{item.data_urodzenia}</td>
                                                    <td className="gocenter">{item.miasto}</td>                                                  
                                                    <td className="gocenter">{item.proponowana_data_przyjecia}</td>                                                  
                                                    <td className="goright"><FormatDecimal value={item.kwota_wpisowa} /></td>                                                  
                                                    <td className="goright"><FormatDecimal value={item.kwota_zaplacona} /></td>    

                                        
                                                    <MenuTable>
                                                        <ul>

                                                            <li  onClick={changeView} v="create" id={item.id}>dodaj do grupy</li>

                                                            <li  onClick={changeView} v="edit" id={item.id}>zmień dane</li>
                                                            <li  onClick={goDelete}  id={item.id}  >usuń</li>
                                                        </ul>
                                                    </MenuTable>

                                        </tr>
                                    } )
                                }
                            </tbody>

                </table>
            </div>



                </div>
                
    </div>
}



export default NoticeOnline;